import { minutesToHHMM } from '@/lib/format';
import type { PublicTenant } from './schemas';

export interface OpenState { open: boolean; allDay: boolean; label: string; todayHours: string | null }

const ISO_WEEKDAY: Record<string, number> = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };

/** Whether the studio is open right now, in the studio's own timezone (never the device's). */
export function openState(t: Pick<PublicTenant, 'hours' | 'exceptions' | 'timezone'>, now = new Date()): OpenState {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en-US', { timeZone: t.timezone, weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(now)
      .map((p) => [p.type, p.value]),
  );
  const day = `${parts.year}-${parts.month}-${parts.day}`;
  const minute = Number(parts.hour) * 60 + Number(parts.minute);
  const exception = t.exceptions.find((e) => e.day === day);
  const regular = t.hours.find((h) => h.weekday === ISO_WEEKDAY[parts.weekday ?? '']);
  const range = exception
    ? exception.is_closed || exception.open_minute === null || exception.close_minute === null
      ? null
      : { open: exception.open_minute, close: exception.close_minute }
    : regular
      ? { open: regular.open_minute, close: regular.close_minute }
      : null;

  if (!range) return { open: false, allDay: false, label: 'Сегодня выходной', todayHours: null };
  const todayHours = `${minutesToHHMM(range.open)}–${minutesToHHMM(range.close)}`;
  const allWeek = !exception && t.hours.length === 7 && t.hours.every((h) => h.open_minute === 0 && h.close_minute === 1440);
  if (allWeek) return { open: true, allDay: true, label: 'Открыто круглосуточно', todayHours };
  if (minute >= range.open && minute < range.close) return { open: true, allDay: false, label: `Открыто до ${minutesToHHMM(range.close)}`, todayHours };
  return { open: false, allDay: false, label: minute < range.open ? `Закрыто · откроется в ${minutesToHHMM(range.open)}` : 'Сейчас закрыто', todayHours };
}
